module.exports = __webpack_public_path__ + "static/media/snickare.1d2cc080.mp3";